import { BrowserRouter as Router } from "react-router-dom";
import "./index.scss";
import AppRoutes from "./AppRoutes";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";

function App() {
  return (
    <Router>
      <AppRoutes />
      <ToastContainer />
    </Router>
  );
}

export default App;
